/**
 * Component Registry for Chestnut Ridge Apartment Homes
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { PropertyOverview } from './components/PropertyOverview';
import { ReviewsCallout } from './components/ReviewsCallout';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  PropertyOverview,
  ReviewsCallout,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
